import styled from "styled-components";
import {
  animations,
  colors,
  devices,
  sizes,
} from "../../utils/styled/_variables.styled";

function renderBg(formSubmitButton) {
	switch (formSubmitButton) {
		case "blue":
			return colors.infiosGray;
		case "green":
			return colors.limeGreen;
		case "greenlight":
		return colors.limeGreen;
		case "white":
		return colors.white;
		default:
			return colors.blue;
	}
}

function renderText(formSubmitButton) {
	switch (formSubmitButton) {
		case "blue":
			return colors.white;
		case "green":
			return colors.infiosGray;
		case "greenlight":
		return colors.infiosGray;
		case "white":
		return colors.infiosGray;
		default:
			return colors.white;
	}
}

export const InfiosContactFormTab = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;

  .link-button {
    display: flex;
    position: relative;
    align-items: center;
    line-height: 24px;
    color: ${colors.gray3};
    white-space: nowrap;
    transition: ${animations.buttonLink};
    cursor: pointer;

    svg {
      margin-left: 10px;
      path {
        transition: ${animations.buttonLink};
        fill: ${colors.gray3};
      }
    }

    &.open {
			color: ${props => props.formBaseColor || colors.blue};

      &:after {
        content: "";
        position: absolute;
        bottom: -21px;
        width: 100%;
        height: 3px;
				background-color: ${props => props.formBaseColor || colors.blue};
        z-index: 1;
      }

      svg {
        path {
					fill: ${props => props.formBaseColor || colors.blue};
        }
      }
    }

    &:hover {
      color: ${props => props.formBaseColor || colors.bluePressed};

      svg {
        path {
          fill: ${props => props.formBaseColor || colors.bluePressed};
        }
      }
    }

    &:active {
      color: $${props => props.formBaseColor || colors.bluePressed};

      svg {
        path {
          fill: $${props => props.formBaseColor || colors.bluePressed};
        }
      }
    }
  }
`;

export const InfiosContactFormOverlay = styled.section`
  position: fixed;
  display: ${(props) => (props.open ? "flex" : "none")};
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: ${colors.white};
  z-index: 100;
  overflow-x: hidden;
  overflow-y: auto;

  .close {
    position: relative;
    width: 40px;
    margin: 32px 0 16px auto;
    padding: 0;
    z-index: 1;
    background-color: ${colors.white};

  }

  .close svg {
    width: 24px;
    height: 24px;
    margin: 0;

    path {
      fill: ${colors.infiosGray};
    }
  }

  .close:hover svg path {
    fill: ${colors.blueHover};
  }

  .close:not(:hover) svg {
    transform: ${props => props.animatedVertically ? animations.vertical : animations.cta};
  }

  .close-collapsed {
    display: none;
  }

  .overlay-wrapper {
    display: flex;
    flex-direction: column;

    p {
			font-size:19px;
      margin-top: 24px;
    }
  }

  .tabs-wrapper {
    display: flex;
    position: relative;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 7px;

    ${InfiosContactFormTab} {
      margin-bottom: 18px;

      span {
        color: ${props => !!props.tabTitle ? props.tabTitle : props.formBaseColor};

        svg path {
          fill: ${props => !!props.tabTitle ? props.tabTitle : props.formBaseColor};
        }

        &:after {
          background: ${props => !!props.tabTitle ? props.tabTitle : props.formBaseColor};
        }
      }

      & + ${InfiosContactFormTab} {
        margin-left: 32px;
      }
    }
  }

  .content-wrapper {
    position: relative;

    &:before,
    &:after {
      content: "";
      display: ${(props) => (props.hasOverflow ? "flex" : "none")};
      position: absolute;
      width: 65px;
      height: 48px;
      pointer-events: none;
      transition: opacity 0.3s ease-out;
    }

    &:before {
      background: linear-gradient(
        270deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 100%
      );
      left: 0;
      top: -62px;
      opacity: ${(props) => (props.showLeftGradient ? 1 : 0)};
    }

    &:after {
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 100%
      );
      top: -62px;
      right: 0;
      opacity: ${(props) => (props.showRightGradient ? 1 : 0)};
    }

    .tab-content {
      display: flex;
      position: relative;
      width: 100%;
      margin-top: 77px;
      padding-bottom: 96px;

      form {
        button[type=submit]:not(.disabled) {
          background: ${props => !!props.formSubmitButton ? renderBg(props.formSubmitButton) : colors.blue};
					color: ${props => !!props.formSubmitButton ? renderText(props.formSubmitButton) : colors.white};

					&:hover {
						background: ${props => !!props.formSubmitButton && props.formSubmitButton === "blue" ? "#E7E7E7" : props.formSubmitButton === "green" ? colors.infiosGray : props.formSubmitButton === "greenlight" ? "#E7E7E7" : props.formSubmitButton === "white" ? colors.infiosGray : colors.blue};
						color: ${props => !!props.formSubmitButton && props.formSubmitButton === "blue" ? colors.infiosGray : props.formSubmitButton === "green" ? colors.white : props.formSubmitButton === "greenlight" ? colors.infiosGray : props.formSubmitButton === "white" ? colors.white : colors.blue};
					}
        }
      }

      &:after {
        content: "";
        width: 200vw;
        position: absolute;
        transform: translateX(-50%);
        top: -83px;
        left: 0;
        right: 0;
        height: 1px;
        background-color: ${colors.gray2};
      }

      @media ${devices.tabletToDesktop} {
        padding-bottom: 48px;
      }

      @media ${devices.mobile} {
        padding-bottom: 24px;
      }
    }
  }

  &.fixed {
    .overlay-wrapper,
    .close {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
    }

    .close-uncollapsed {
      display: none;
    }

    .overlay-wrapper {
      background-color: ${colors.white};
      z-index: 20;
      padding: 32px 96px;
      width: 100vw;
      max-width: 100%;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      span {
        max-width: ${sizes.desktop - 1}px;
        width: 100%;
        margin: 0 auto;
        padding-right: 48px;
      }

      p {
        display: none;
      }

      .close-collapsed {
        position: static;
        display: block;
        margin: 0;
      }

      @media ${devices.tabletToDesktop} {
        padding: 28px 48px;
      }

      @media ${devices.mobile} {
        padding: 24px;
      }
    }

    .tabs-wrapper {
      margin-top: 200px;
    }

    .close {
      z-index: 25;
      margin-right: 96px;

      @media ${devices.mobileToDesktop} {
        margin-right: 48px;
      }
    }
  }

  .form__subtitle {
    margin-bottom: 48px;

    @media ${devices.mobile} {
      margin-bottom: 40px;
    }
  }

	.frc-content {
    a, button {
      color: ${props => props.formLinksColor || colors.blue};
    }
  }

  .close:hover {
    svg path {
      fill: ${props => props.formLinksColor || colors.blue};
    }
  }

  input, select, textarea {
    &:hover, &:active, &:focus {
      border-color: ${props => props.formBaseColor || colors.blue};
    }
  }

  select:active ~ div, select:focus ~ div {
    svg path {
      fill: ${props => props.formBaseColor || colors.blue};
    }
  }



  .checkbox {
    &:hover {
      &:before {
        border: 2px solid ${props => props.formBaseColor || colors.blue};
      }
    }

    a {
      color: ${props => props.formLinksColor || colors.blue};
    }

    > div {
      background: ${props => props.formBaseColor || colors.blue};
    }
  }

  .content-wrapper {
    .aem-container {
      button:not(.disabled) {
        background-color: ${props => props.formBaseColor || colors.blue};
      }
    }
  }
`;
